import { TabPane } from "reactstrap";
import React, { useMemo, useState } from "react";
import SettingsPanel from "../../components/SettingsPanel";
import ProductStockStorageLocation from "./ProductStockStorageLocation";
import ProductStockTransactionReason from "./ProductStockTransactionReason";
import FoodAllergen from "./FoodAllergen";
import FoodDietType from "./FoodDietType";
import AttributesSettings from "./Attributes";
import ProductCategory from "./ProductCategory";

const ProductSettings = () => {
  const [activeTab, setActiveTab] = useState("6");
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const Tabs = [
    // Task 24745 - first, because it organises the catalogue rather than
    // configuring a corner of it.
    {
      id: "6",
      name: "Categories",
    },
    {
      id: "1",
      name: "Stock Location",
    },
    {
      id: "5",
      name: "Stock Reduction Reason",
    },
    {
      id: "2",
      name: "Food Allergen",
    },
    {
      id: "3",
      name: "Food Diet Type",
    },
    {
      id: "4",
      name: "Attributes",
    },
  ];

  const Content = useMemo(() => {
    return [
      {
        id: "6",
        content: <ProductCategory />,
      },
      {
        id: "1",
        content: <ProductStockStorageLocation />,
      },
      {
        id: "5",
        content: <ProductStockTransactionReason />,
      },
      {
        id: "2",
        content: <FoodAllergen />,
      },
      {
        id: "3",
        content: <FoodDietType />,
      },
      {
        id: "4",
        content: <AttributesSettings />,
      },
    ];
  }, [activeTab, selectedDepartment]);
  return (
    <SettingsPanel
      title="Product Settings"
      description="Catalogue categories, stock locations, food allergens, diet types and product attributes."
      tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
      value={activeTab}
      onChange={setActiveTab}
    >
      <TabPane tabId={activeTab}>
        {Content?.find((item) => item.id === activeTab).content}
      </TabPane>
    </SettingsPanel>
  );
};

export default ProductSettings;
